export default "__VITE_ASSET__B40$IOcp__"